module.exports = __webpack_public_path__ + "static/media/2.06ae86f2.jpg";